import { Component, OnDestroy, OnInit } from '@angular/core';
import { DataShareService } from 'services/data-share.service';
import { getDaysOver, isPastPaymentGrace } from 'app/shared/billing/payment-grace';
import { APIService, AccountMembership, AccountType, ActionType, EntityType, ModelAccountUpdatesFilterInput, User, UserStatus } from 'app/API.service.custom';
import { ToastrService } from 'ngx-toastr';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, Subscription } from 'rxjs';
import { AuthService } from '../auth.service';
import { CognitoUser } from 'app/core/auth-shim';
import { filter, find } from 'lodash-es';
import { DialogService } from 'app/shared/dialog';
import { UserComponent } from 'app/shared/admin/user/user.component';
import { MatButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { fetchAllUsersByAccount } from 'app/shared/account/users-by-account-pagination';

@Component({
    selector: 'app-payments',
    templateUrl: './payments.component.html',
    styleUrls: ['./payments.component.scss'],
    imports: [MatButton, MatMenuTrigger, MatMenu, MatMenuItem]
})
export class PaymentsComponent implements OnInit, OnDestroy {

  accountId;

  name = 'Angular';
  totalSeats = 0;

  private userId = null;
  private busy_ = new BehaviorSubject(false);
  public busy = this.busy_.asObservable();
  isLoading = true
  private errorMessage_ = new BehaviorSubject('');
  public errorMessage = this.errorMessage_.asObservable();

  private userDetails_: BehaviorSubject<any> = new BehaviorSubject(undefined);
  public userDetails = this.userDetails_.asObservable();
  private registeredUser: User = null;
  private activeAccountMemberships: AccountMembership[] = [];
  activeAccount : AccountMembership = null
  availableMemberships : AccountMembership[] = [];
  fetchedUsers: AccountMembership[] = [];
  daysOverPaidFor : number = null;
  /** True while the 7-day grace after paidForTillDate has not elapsed (dashboard still reachable). */
  withinPaymentGrace = false;
  private routeParamSubscription?: Subscription;

  
  constructor(
    private dataService: DataShareService,
    private api: APIService,
    private toastr: ToastrService,
    private titleService: Title,
    private route: ActivatedRoute,
    private router: Router,
    private auth: AuthService,
    private sidebarService: DialogService,
    ) { }

  ngOnInit() {
    this.titleService.setTitle('Trial');
    this.routeParamSubscription = this.route.paramMap.subscribe(params => {
      this.accountId = params.get('id');
      this.getUserDetailsAndId();
      this.getAllUsersInAccount();
    });

  }

  ngOnDestroy(): void {
    this.routeParamSubscription?.unsubscribe();
  }

  getAllUsersInAccount() {
    fetchAllUsersByAccount(this.api, this.accountId).then(users => {
      console.log('All Users Fetched for the account. Count:', users.length);
      this.fetchedUsers = users;
    })
      .catch(e => {
        console.log('Error Fetching Users for the account', e);
        this.showErrorInToastr(e, 'Error Fetching Users')
      });
  }

  viewMembers(){
    this.sidebarService.open(UserComponent, {
      data: { fetchedUserMemberships: this.fetchedUsers }
    }, 1);
  }

  public async getUserDetailsAndId() {
    this.busy_.next(true);
    this.errorMessage_.next('');
    try {
      const userDetails: CognitoUser = await this.auth.currentAuthenticatedUser();
      this.userId = userDetails.getSignInUserSession().getIdToken().payload.userId;
      if (this.userId) {
        this.getUserRegistrationDetail(this.userId);
      }
      this.userDetails_.next(userDetails);
    } catch (err) {
      this.errorMessage_.next(err.message || err);
    } finally {
      this.busy_.next(false);
    }
  }

  private getUserRegistrationDetail(userId: string) {
    this.api.GetUser(userId).then(async event => {
      console.log('User Registration Detail Fetched : ', event);
      if (event) {
        this.registeredUser = event;
        this.dataService.setRegisteredUser(this.registeredUser)
        this.getuserAccountMemberships(event);
      }
    })
      .catch(e => {
        console.log('error fetching user registration detail', e);
      });

  }

  private getuserAccountMemberships(user: User) {
    this.api.AccountsByUser(user.id).then(event => {
      console.log('User Account Memberships Fetched : ', event);
      if (event && event.items && event.items.length > 0) {
        event.items.forEach(item => {
          item.user = user;
        });
        this.activeAccountMemberships = filter(event.items, function(o) { 
          return (o.userAccountStatus == UserStatus.ACTIVE || o.userAccountStatus == UserStatus.APPROVED) && (o.account.accountType == AccountType.TEAM || o.account.accountType == AccountType.TEAM_TRIAL);
        });
      
        console.log("activeAccountMemberships memberships are ", this.activeAccountMemberships);
        if(this.activeAccountMemberships.length > 0){
          if(this.accountId != null && this.accountId != ""){
            this.activeAccount = find(this.activeAccountMemberships, { 'accountId': this.accountId});
            this.checkIfAccountToBeBlocked();
            this.totalSeats = this.activeAccount.account.seats || 0 + this.activeAccount.account.freeSeats || 0;
            if(this.activeAccount && this.activeAccount.account && this.activeAccount.account.accountType == AccountType.TEAM_TRIAL && (this.activeAccount.account.trialAccountEndDate < (new Date()).toISOString())){
              var membershipAccountId = this.activeAccount.accountId;
              this.availableMemberships = filter(this.activeAccountMemberships, function(o) { 
                return o.account.id != membershipAccountId && (!o.account.trialAccountEndDate || o.account.trialAccountEndDate > (new Date()).toISOString()); 
            });
            console.log("Available memberships are ", this.availableMemberships);
            }
          }
          else
            this.activeAccount = this.activeAccountMemberships[0];
        }
        this.isLoading = false;
      }
    })
      .catch(e => {
        console.log('error fetching user account memberships', e);
        this.isLoading = false;
      });
  }

  checkIfAccountToBeBlocked(){
    if(this.activeAccount.account.accountType == AccountType.TEAM){
      const now = new Date();
      this.daysOverPaidFor = getDaysOver(this.activeAccount.account.paidForTillDate, now);
      this.withinPaymentGrace = !isPastPaymentGrace(this.activeAccount.account.paidForTillDate, now);
    }else{
      this.daysOverPaidFor = null;
      this.withinPaymentGrace = false;
    }
  }

  goToDashboard(){
    this.router.navigate(['/']);
  }

  public checkout() {
    this.toastr.info('Online payments are currently disabled. Please contact support to settle your dues.');
  }

  getMembersAsOnBillingDate(){
    let f = <ModelAccountUpdatesFilterInput>{};
    let billingDate = this.activeAccount.account.paidUpTo;
    let date = new Date(billingDate);
    date.setHours(23, 59, 59, 999);
    f.actionType = {eq : ActionType.CREATE}
    f.entityType = {eq : EntityType.AccountMembership}
    f.updatedAt = {}
    this.api.GetAccountChangesByAccount
  }

  showErrorInToastr(e, title) {
    if (e.errors && e.errors.length > 0) {
      for (let _i = 0; _i < e.errors.length; _i++) {
        this.toastr.error(title, e.errors[_i].message);
        console.log(e.errors[_i].message);
      }
    }
  }
  

}

